<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>DESADV szállítólevelek</span>
      <el-button
        v-can="'desadv.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/sales/desadvs/add')"
      >
        Új DESADV
      </el-button>
    </div>
    <div
      v-loading="loading"
      style="min-height: 81px;"
    >
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="desadv/fetchAll"
      />
    </div>
    <desadv-list />
    <template v-if="$route.meta.showAddDesadvDialog">
      <desadv-create-dialog key="desadv-add" />
    </template>
    <template v-if="$route.meta.showDesadvViewDialog">
      <desadv-dialog
        :key="'desadv-view-' + desadvRouteId"
        :desadv-id="desadvRouteId"
      />
    </template>
  </el-card>
</template>

<script>
import desadvList from '../../components/sales/desadvs/List';
import desadvDialog from '../../components/sales/desadvs/Dialog';
import desadvCreateDialog from '../../components/sales/desadvs/CreateDialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    desadvList,
    desadvDialog,
    desadvCreateDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  computed: {
    // The pallet editor route deep links into the same DESADV dialog, with a different param name.
    desadvRouteId() {
      return this.$route.params.id || this.$route.params.desadvId;
    },
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      this.filterConfig = [
        {
          type: 'text',
          name: 'customer_order_receipt_number',
          label: 'Vevői megrendelés',
          defaultSearch: true,
        },
        {
          type: 'text',
          name: 'despatch_advice_number',
          label: 'Bizonylatszám',
        },
        {
          type: 'date',
          name: 'delivery_date',
          label: 'Szállítás dátuma',
        },
        {
          type: 'date',
          name: 'created_at',
          label: 'Rögzítés dátuma',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Nyitott',
              status: 'open'
            },
            {
              label: 'Véglegesítve',
              status: 'finalized'
            },
            {
              label: 'Részben szállítva',
              status: 'partially_shipped'
            },
            {
              label: 'Szállítva',
              status: 'shipped'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
      ];
    },
  },
};
</script>
